export default {
    async getFileBase64(file) {
        if (file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => {
                    resolve(reader.result)
                }
                reader.onerror = reject
                reader.readAsDataURL(file)
            })
        } else {
            return null
        }
    },
}
